import React from 'react';
import Axios from 'axios';

import { Logger, AsyncStorage } from 'services';
import { apiOrganizationEndpoints } from 'helpers/endpoints';

export const useSaveOnboarding = (organizationId?: string, onboardingStep?: string) => {
  React.useEffect(() => {
    if (organizationId && onboardingStep) {
      const endpoint = apiOrganizationEndpoints(organizationId).updateOrganizationMemberSettings;

      AsyncStorage.get('refreshToken').then((token) => {
        Axios.patch(
          endpoint,
          { onboarding_step: onboardingStep },
          {
            headers: {
              'Content-Type': 'application/json',
              'fyi-organization': organizationId,
              'fyi-authorization': 'Bearer ' + token,
            },
          }
        )
          .then(() => {
            Logger.log('Updated onboarding step on server:', onboardingStep);
          })
          .catch(() => {
            Logger.log('Failed to update onboarding step on server');
          });
      });
    }
  }, [organizationId, onboardingStep]);
};
